// 顶部背景
export const BRAND_BACKGROUND = 'background'
export const BRAND_CENTER = 'center'
